import { BaseTimeline } from './Timeline'
import { TimelineItem } from './TimelineItem'

export type TimelineComponent = typeof BaseTimeline & {
  Item: typeof TimelineItem
}

export const Timeline = BaseTimeline as TimelineComponent
Timeline.Item = TimelineItem

Timeline.displayName = 'Timeline'
Timeline.Item.displayName = 'Timeline.Item'
